//**************************************************************************************************
//  フッター
//**************************************************************************************************
//==================================================================================================
//  import
//==================================================================================================
import { Component } from '@angular/core';

import { CommonModule } from '@angular/common';

import { MatToolbarModule } from '@angular/material/toolbar';

import { TranslatePipe } from "@ngx-translate/core";

import { AppConst } from '../../app-const';

import { SessionService } from '../services/session-service';
import { Session } from '../../class/session';

import { FireSysAdmin } from '../models/fire/sys_admin';
import { FireLeAdmin } from '../models/fire/le_admin';
import { FireLeUser } from '../models/fire/le_user';
import { FireEventInfo } from '../models/fire/event_info';
import { FireEventShow } from '../models/fire/event_show';
import { FireReserveInfo } from '../models/fire/reserve_info';

import { environment } from '../../../environments/environment';
import { FireBasicSetting } from '../models/fire/basic_setting';
//==================================================================================================
//  Component
//==================================================================================================
@Component({
  selector: 'app-footer',
  imports: [
    CommonModule,
    TranslatePipe,
    MatToolbarModule
  ],
  templateUrl: './footer.html',
  styleUrl: './footer.css'
})
//==================================================================================================
//  class
//==================================================================================================
export class Footer {
  //================================================================================================
  //  変数定義
  //================================================================================================
  isLogin                       : boolean                 = false;
  //------------------------------------------------------------------------------------------------
  sessionUid                    : string | null           = null;                                   //  セッション情報：UID
  sessionSysAdmin               : FireSysAdmin | null     = null;                                   //  セッション情報：システム管理者
  sessionLeAdmin                : FireLeAdmin | null      = null;                                   //  セッション情報：LE管理者
  sessionLeUser                 : FireLeUser | null       = null;                                   //  セッション情報：LEユーザー
  sessionBasicSetting           : FireBasicSetting | null = null;                                   //  セッション情報：基本設定
  sessionEventInfo              : FireEventInfo | null    = null;                                   //  セッション情報：興行
  sessionEventShow              : FireEventShow | null    = null;                                   //  セッション情報：公演
  sessionReserveInfo            : FireReserveInfo | null  = null;                                   //  セッション情報：予約
  //------------------------------------------------------------------------------------------------
  time                          = new Date();
  intervalId                    : any;
  appConst                      = AppConst;
  environment                   = environment.environment;
  //================================================================================================
  //  コンストラクタ
  //================================================================================================
  constructor(
    private sessionService: SessionService) { }
  //================================================================================================
  //  初期処理
  //================================================================================================
  ngOnInit(): void {
    this.sessionService.sessionState.subscribe((session: Session)=> {
      if (session) {
        this.isLogin              = session.isLogin;
        this.sessionUid           = session.uid;
        this.sessionSysAdmin      = session.sysAdmin;
        this.sessionLeAdmin       = session.leAdmin;
        this.sessionLeUser        = session.leUser;
        this.sessionBasicSetting  = session.basicSetting;
        this.sessionEventInfo     = session.eventInfo;
        this.sessionEventShow     = session.eventShow;
        this.sessionReserveInfo   = session.reserveInfo;
      }
    })
    this.intervalId = setInterval(() => {
      this.time = new Date();
    }, 1000);
  }
  //================================================================================================
  //  終了処理
  //================================================================================================
  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }
}
